import { useContext, useEffect, useState } from "react";
import { getAthleteTrainingSession, getCoachTrainingSession } from "../../services/training-session";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from '@fullcalendar/daygrid';
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import moment from 'moment';
import { t } from "i18next";
import trainingIcon from "../../assets/images/trainings.svg";
import { Link, useNavigate } from "react-router-dom";
import esLocale from '@fullcalendar/core/locales/es';
import { LoadingSpinner } from "../general/loading-spinner";
import { getAthletePlanning } from "../../services/planning";
import { UserContext } from "../../App";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export function AthleteMiniCalendarBlock() {
    const navigate = useNavigate();

    const { userProfile } = useContext(UserContext);
    
    const [events, setEvents] = useState<any[]>([]);
    const [planning, setPlanning] = useState<any[]>([]);
    const [loaded, setLoaded] = useState(true);

    // Función para eliminar sesiones duplicadas
    const getUniqueSessions = (trainings: any[]) => {
        const seen = new Set();
        return trainings.filter((training: any) => {
            const key = `${training.session}-${training.description}-${training.color}-${training.team_id}`;
            if (seen.has(key)) {
                return false;
            }
            seen.add(key);
            return true;
        });
    }

    const renderTooltip = (props: any) => {
        const training = props.event?._def?.extendedProps;

        return (
            <Tooltip id={`tooltip-${training?.team_id || 'unknown'}-${training?.day || 'unknown'}-${training?.session || '0'}`} className="event-tooltip" {...props}>
                {training ? (
                    <>
                        <div style={{fontWeight: 'bold', marginBottom: '5px'}}>{training.team_name}</div>
                        <div className="training-info-item">
                            <div className="description">
                                <strong>S{training.session}: </strong>
                                {training.description}
                            </div>
                        </div>
                    </>
                ) : (
                    <div>No data</div>
                )}
            </Tooltip>
        );
    }

    function eventContent(arg: any) {
        return (
            <OverlayTrigger placement="top" delay={{ show: 250, hide: 1000 }} overlay={renderTooltip(arg)}>
                <span className={ arg.event.classNames } style={{cursor: 'pointer'}}>
                    {arg.event.title}
                </span>
            </OverlayTrigger>);
    }

    useEffect(() => {
        getAthletePlanning(userProfile.id)
            .then(response => {
                console.log(response.data);
                setPlanning(response.data);

                // Transformar datos: crear un evento por cada sesión única
                const calendarEvents: any[] = [];
                response.data.forEach((dayData: any) => {
                    const uniqueTrainings = getUniqueSessions(dayData.trainings);
                    uniqueTrainings.forEach((training: any, index: number) => {
                        calendarEvents.push({
                            id: `${dayData.day}-${training.team_id}-${training.session}-${index}`,
                            title: `${training.team_name} - S${training.session}`,
                            date: moment(dayData.day).format('YYYY-MM-DD'),
                            day: dayData.day,
                            session: training.session,
                            description: training.description,
                            team_id: training.team_id,
                            team_name: training.team_name,
                            color: training.color || '#34B689'
                        });
                    });
                });

                setEvents(calendarEvents);
                setLoaded(true);
            });
    }, []);

    const handleCalendarChange = (event: any) => {
        const start_time = moment(event.startStr).format('Y-MM-DD 00:00:00');
        const end_time = moment(event.endStr).format('Y-MM-DD 23:59:59');
        
        getAthleteTrainingSession(start_time, end_time)
            .then(response => {
                setEvents(response.data.map((e: any) => {
                    return {
                        id: e.id.toString(),
                        title: e.name,
                        // classNames: ['training'], 
                        date: moment(e.date_time).format('YYYY-MM-DD'),
                        time: moment(e.date_time).format('HH:mm:ss'),
                        url: '/athlete/training-sessions/' + e.id + '/view',
                        color: e.color
                        /*rrule: {
                            freq: 'daily',
                            interval: 1,
                            dtstart: moment(e.date_start).format('YYYY-MM-DD'), // will also accept '20120201T103000'
                            until: moment(e.date_end).format('YYYY-MM-DD') // will also accept '20120201'
                        },*/
                    }
                }));
                setLoaded(true);
            })
            .catch(error => {
                console.log(error);
            });
    }

    return (
        <div className="block mini-calendar-container">
            <div className="block-inner">
                <h3 className="block-title">
                    <img src={ trainingIcon } alt={ t("trainings")} />
                    { t("trainings") }
                </h3>
                { !loaded && 
                    <LoadingSpinner />
                }
                { loaded && 
                    <FullCalendar
                            plugins={[ dayGridPlugin, bootstrap5Plugin ]}
                            initialView="dayGridMonth"
                            weekends={true}
                            firstDay={ 1 }
                            locale={esLocale}
                            height={ 'auto' }
                            events={ events }
                            eventContent= { eventContent }
                            // datesSet={ handleCalendarChange }
                        />
                }
                { loaded &&
                    <div className="events-list">
                        {
                            events.map((event: any, eventIndex: number) => {
                                return (
                                    <div key={ `event-${event.day}-${event.team_id}-${event.session}-${eventIndex}` } className="event-item" style={{position: 'relative', paddingLeft: '30px'}}>
                                        <div className="color-mark" style={{backgroundColor: event.color}}></div>
                                        <div className="name">
                                            <div style={{fontSize: '0.85em', color: '#888', fontWeight: 'bold'}}>{event.team_name}</div>
                                            <strong>S{event.session}: </strong>
                                            { event.description }
                                        </div>
                                        <div className="date">
                                            { moment(event.day).format('D MMMM') }
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                }
            </div>
        </div>
    );
}  
